<template>
  <div v-if="loading" style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
  <div v-else class="pay">
    <div class="pay-hd">
      <div class="userinfo flex flex-align-center">
        <van-image
          fit="cover"
          height="48"
          round
          :src="api.FileHost + payData.CustomerAvatar"
          width="48"
        >
          <template #error>{{ payData.CustomerNickName || '用户' }}</template>
        </van-image>
        <p>{{ payData.CustomerNickName || '用户' }}</p>
      </div>
      <div class="product-info">
        <dl v-for="(item, key) in payData.Products" :key="key" class="flex">
          <dt>
            <van-image
              fit="cover"
              height="90"
              :src="api.FileHost + item.BannerPicture"
              style="border-radius: 3px; overflow: hidden"
              width="160"
            >
              <template #error>{{ item.ProductName }}</template>
            </van-image>
          </dt>
          <dd>
            <h2>{{ item.ProductName }}</h2>
            <p>￥{{ moneyStr(item.UnitPrice) }}</p>
          </dd>
        </dl>
      </div>
      <div class="pay-info">
        <ul>
          <li class="flex">
            <span class="key flex-1">总计</span>
            <span class="value">
              ￥{{ moneyStr(payData.PayableTotalAmount) }}
            </span>
          </li>
          <li v-if="isSalesPay" class="flex">
            <span class="key flex-1">已支付</span>
            <span class="value">
              ￥{{ moneyStr(payData.AccumulatedAmount) }}
            </span>
          </li>
          <li
            v-if="!isSalesPay && payData.DiscountAmount > 0"
            class="flex"
            @click="showCoupon"
          >
            <span class="key flex-1">优惠券抵扣</span>
            <span class="value">￥{{ moneyStr(payData.DiscountAmount) }}</span>
            <div class="check-box">
              <van-icon name="arrow" />
            </div>

            <!-- <span class="key flex-1">优惠券抵扣</span>
            <div class="value check-box" @click="ckeckCoupon">
              <span v-if="true">￥200</span>
              <span v-else class="check-text">请选择</span>

              <van-icon name="arrow" />
            </div> -->
          </li>
          <li class="flex">
            <span class="key flex-1">剩余应付</span>
            <span class="value red">
              ￥{{ moneyStr(payData.RemainAmount) }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="pay-bd">
      <!-- 销售云支付 -->
      <div v-if="isSalesPay" class="input-box">
        <div class="box-hd">
          <span>输入</span>
          <span>支付金额</span>
        </div>
        <div class="box-bd">
          <van-field
            v-model="Amount"
            clickable
            label="￥"
            label-class="money-icon"
            label-width="20px"
            placeholder="输入支付金额"
            readonly
            size="large"
            style="font-size: 26px; padding-left: 0"
            @touchstart.stop="showInput"
          />
          <van-cell />
          <van-number-keyboard
            v-model="Amount"
            close-button-text="完成"
            extra-key="."
            :show="show"
            theme="custom"
            @blur="show = false"
            @input="AmountInput"
          />
        </div>
      </div>
      <!-- 优惠券支付 -->
      <div v-else class="input-box coupon-pay">
        <div class="box-hd">
          <span>支付金额</span>
        </div>
        <div class="box-bd mt10">￥{{ moneyStr(payData.RemainAmount) }}</div>
      </div>
      <van-button
        block
        color="#00c250"
        :loading="openPayLoading"
        @click.stop="goPay"
      >
        确认并微信支付
      </van-button>
      <!-- 阅读并同意协议 -->

      <div
        v-if="!isSalesPay && agreementData.NeedSign"
        class="protocol"
        @click="goAgreement"
      >
        <div class="protocol-icon">
          <van-icon v-if="agreementData.IsSigned" name="passed" />
          <van-icon v-else name="circle" />
        </div>
        <div class="protocol-text">
          阅读并同意《
          <a href="javascript:;" @click.stop="goAgreement">用户服务协议</a>
          》
        </div>
      </div>
      <div v-if="isSalesPay" class="tips">
        <p>支持把订单分享给其他微信好友帮你支付</p>
        <a href="javascript:;" @click="showShare">如何操作？</a>
      </div>
    </div>
  </div>
  <van-overlay :show="showOverlay" @click="showOverlay = false">
    <ul class="share-box">
      <li class="icon">①点击右上角 ...</li>
      <li>
        ②点击
        <van-icon name="share-o" />
        分享给其他微信
      </li>
    </ul>
  </van-overlay>
  <PayStatus ref="REFPayStatus" @close="PayStatusClose" />
  <van-popup
    v-model:show="couponShow"
    close-icon="close"
    closeable
    position="bottom"
    round
    :style="{ height: '75%' }"
  >
    <div class="content-coupon">
      <div class="coupon-title">优惠券</div>
      <div class="list">
        <div v-if="couponItems.length < 1">
          <van-empty description="暂无优惠券~" />
        </div>
        <div
          v-for="(item, index) in couponItems"
          v-else
          :key="index"
          class="list-item"
        >
          <div class="check-raido">
            <!-- <van-icon v-if="isCheck" class="no-ckeck" name="circle" size="20" /> -->
            <van-icon class="is-check" name="passed" size="20" />
          </div>

          <div class="coupon">
            <div class="coupon-text1">
              <div class="coupon-money">
                <span class="icon">￥</span>
                <span class="price">
                  {{ moneyStr(item.DiscountAmount || 0) }}
                </span>
              </div>
              <div class="coupon-name">{{ item.PackageName }}</div>
            </div>
            <div class="coupon-text2">
              <div>【{{ item.ProductName }}】 专属券</div>
              <div>
                使用期限：{{
                  dateFormat(item.EffectiveTime, 'yyyy-MM-dd hh:mm:ss')
                }}
                ~
                {{
                  dateFormat(item.Deadline, 'yyyy-MM-dd hh:mm:ss') || '长期有效'
                }}
              </div>
              <!-- <div>
                使用期限：{{ '2020-03-02 12:30:30' }} ~
                {{ '2020-03-02 ' }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script setup>
  import { dateFormat } from '@/utils/filters'
  import { onMounted, ref, computed, watch } from 'vue'
  import api from '@/api'
  import store from '@/store'
  import { Dialog, Notify, Toast, toast } from 'vant'
  import { useRouter, useRoute } from 'vue-router'
  import qs from 'qs'
  import { wxShare, floatDiv, floatMul, clearNum } from '@/utils'
  import storage from '@/utils/storage'
  import { moneyStr } from '@/utils/filters'
  import PayStatus from './components/PayStatus.vue'
  const REFPayStatus = ref(null)
  const Amount = ref()
  const show = ref(false)
  const showOverlay = ref(false)
  const route = useRoute()
  const router = useRouter()
  const query = route.query
  const loading = ref(true)
  const query2 = JSON.parse(JSON.stringify(query))
  const couponShow = ref(false)
  const isCheck = ref(true)
  delete query2.openid
  const redirect = qs.stringify(query2)
  //协议信息
  const agreementData = ref({})
  // 订单优惠券列表
  const couponItems = ref([])
  // 支付主信息
  const payData = ref({})
  const openPayLoading = ref(false)
  const getUrlKey = (name) => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var rrr = decodeURIComponent(window.location.search)
    var r = rrr.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  }
  let isPageHide = false
  let code = ''
  let openid = query.openid || storage.get('openid')
  window.addEventListener('pageshow', function () {
    if (isPageHide) {
      window.location.reload()
    }
  })
  window.addEventListener('pagehide', function () {
    isPageHide = true
  })
  onMounted(async () => {
    if (query.type === 'sales') {
      let url = await store.getters['system/getH5Url']
      url += `home/#/pagesPay/settlement/sales?type=sales&orderNo=${query.orderNo}`
      location.href = url
      return
    }

    if (query.type === 'coupon') {
      let url = await store.getters['system/getH5Url']
      url += `home/#/pagesPay/settlement/service?type=coupon&orderNo=${query.orderNo}`
      location.href = url
      return
    }

    //wx.test.com/zeyu/home/#/pagesPay/settlement/sales?type=sales&orderNo=1619271283369971712
    // console.log('onMounted')
    // 如果有code 说明微信登录回调回来了
    code = getUrlKey('code')
    // 没有code 且没有openid 先拿code 换openid
    if (!code && !openid) {
      getCode()
      return
    }
    // 有code 没有openid 则调接口换openid
    if (!openid && code) {
      getWXOpenId(code)
      return
    }

    // 有openid 获取支付信息
    await getPayInfo()
    //获取产品协议和用户签署信息
    GetAgreementWithSignatureInfo()
    if (query.type !== 'sales') {
      couponList()
    }
    loading.value = false
    share()
  })

  //打开优惠券列表
  const showCoupon = () => {
    couponShow.value = true
  }
  //获取优惠券列表
  const couponList = () => {
    const params = {
      orderNo: query.orderNo,
    }
    store
      .dispatch('service/GetFormOrderCoupon', params)
      .then((data) => {
        const { Data, Code } = data
        if (Code === 0) {
          couponItems.value = Data.Coupons
        }
      })
      .catch((e) => {
        // Toast.fail(e.Message || '获取订单优惠券失败')
      })
  }

  const GetAgreementWithSignatureInfo = () => {
    const param = {
      productId: payData.value.Products[0].ProductId,
    }
    Toast.loading({
      duration: 0,
      forbidClick: true,
      message: '加载中',
    })
    store
      .dispatch('service/FormGetAgreementWithSignatureInfo', param)
      .then((data) => {
        const { Data } = data
        agreementData.value = Data
        Toast.clear()
      })
      .catch((e) => {
        Toast.fail(e.Message || '获取协议信息失败')
      })
  }

  const share = () => {
    const shareUrl = getRefreshUrl()
    wxShare(
      '',
      `《${payData.value.Products[0].ProductName}》这个产品太牛了，帮我付一笔吧！`,
      '',
      shareUrl
    )
  }

  // 唤起微信支付
  const goPay = () => {
    if (
      !isSalesPay.value &&
      agreementData.value.NeedSign &&
      !agreementData.value.IsSigned
    ) {
      Dialog.confirm({
        title: '提示',
        message: '请先签署协议',
        confirmButtonText: '立即签署',
        cancelButtonText: '取消',
        confirmButtonColor: '#3662EC',
      })
        .then(async () => {
          const H5Url = await store.getters['system/getH5Url']
          const url = `${H5Url}service/#/agreement?ProdId=${payData.value.Products[0].ProductId}&fromCase=true`
          window.location.href = url
          // router.push({
          //   path: '/agreement',
          //   query: {
          //     ProdId: payData.value.Products[0].ProductId,
          //   },
          // })
        })
        .catch(() => {
          // console.log('fail')
        })
      return
    }

    if (payData.value.RemainAmount > 0 && !Amount.value) {
      Toast.fail('支付金额不能为空')
      return
    }
    const amount = Amount.value > 0 ? floatMul(Amount.value, 100) : 0
    openPayLoading.value = true
    // 销售流程 如果剩余支付为0 点击支付时直接展示支付成功页面
    if (query.type === 'sales' && payData.value.RemainAmount === 0) {
      REFPayStatus.value.show(Amount, 'done')
      return
    }

    // 销售云流程支付
    let url = 'pay/SalesWorkFlowJsapiPayment'
    // 服务云支付
    if (query.type === 'coupon') {
      // url = 'service/PackageJsapiPayment'
      url = 'service/FormJsapiPayment'
    }
    store
      .dispatch(url, {
        orderNo: query.orderNo,
        openid,
        amount,
      })
      .then((data) => {
        const { Code, Data } = data
        if (Code === 0) {
          if (Data.NeedPay === false) {
            // 实际支付为0元的无需唤醒支付
            REFPayStatus.value.show(Amount, 'done')
          } else {
            wxPay(Data, amount)
          }
        } else {
          Toast.fail('唤起支付失败')
        }
      })
      .catch((e) => {
        Toast.fail(e.Message || '唤起支付失败')
        // router.back()
      })
      .finally(() => {
        openPayLoading.value = false
      })
  }

  const wxPay = (data, Amount) => {
    wx.chooseWXPay({
      timestamp: data.TimeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
      nonceStr: data.NonceStr, // 支付签名随机串，不长于 32 位
      package: data.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
      signType: data.SignType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
      paySign: data.PaySign, // 支付签名
      success: (res) => {
        // console.log(res)
        // 支付成功后展示
        REFPayStatus.value.show(data.OutTradeNo, Amount)
        // 支付成功后的回调函数
      },
      fail: (error) => {
        console.log(error)
      },
    })
  }
  /**
   * 获取支付信息
   * @author hanson.liu
   * @date 2022-09-01
   * @returns {any}
   */
  const getPayInfo = () => {
    return store
      .dispatch('pay/GetPaymentOrderForSettlement', {
        orderNo: query.orderNo,
      })
      .then((data) => {
        const { Data, Code } = data
        if (Code === 0) {
          Amount.value =
            Data.RemainAmount > 0
              ? floatDiv(Data.RemainAmount, 100)
              : Data.RemainAmount
          payData.value = Data
          if (!Data.IsPading) {
            Toast.fail('信息已过期，请重新生成~')
            setTimeout(() => {
              router.back()
            }, 1000)
          }
        } else {
          Toast.fail('获取支付信息失败')
        }
      })
      .catch((e) => {
        Toast.fail(e.Message || '获取支付信息失败')
      })
  }

  /**
   * 获取wx code 用于获取openid
   * @author hanson.liu
   * @date 2022-08-30
   * @returns {any}
   */
  const getCode = async () => {
    await store
      .dispatch('user/WechatGetAppID')
      .then((data) => {
        const { Code, Data } = data
        if (Code !== 0) {
          Notify('获取appId失败，请稍后重试！')
          return
        }
        const appId = Data.AppId
        const state = Data.State
        const origin = location.origin
        const pathname = location.pathname
        let url = `${origin}${pathname}#${route.path}?${redirect}`
        url = encodeURIComponent(url)
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
      })
      .catch((e) => {
        Notify('获取appId失败，请稍后重试！')
      })
  }

  /**
   * 获取openid 并保存至localstorage
   * @author hanson.liu
   * @date 2022-08-30
   * @param {any} code
   * @returns {any}
   */
  const getWXOpenId = async (code) => {
    const tenant = await store.getters['user/getTenant']
    store
      .dispatch('user/GetWechatOpenId', {
        Code: code,
      })
      .then(async (data) => {
        const { Code, Data } = data
        if (Code === 0) {
          storage.set('openid', Data)
        } else {
          console.log('获取openId失败')
        }
        refresh()
      })
      .catch((e) => {
        refresh()
        console.log('获取openId失败')
      })
  }

  //刷新页面
  const refresh = (query) => {
    let url = getRefreshUrl()
    if (query) url += query
    window.location.href = url
  }
  const getRefreshUrl = () => {
    const origin = location.origin
    const pathname = location.pathname
    let url = `${origin}${pathname}#${route.path}?${redirect}`
    return url
  }

  // 显示分享提示
  const showShare = () => {
    showOverlay.value = true
  }

  // 支付状态弹出层关闭
  const PayStatusClose = () => {
    getPayInfo()
  }
  // 是否是销售流程上的支付
  const isSalesPay = computed(() => {
    let res = true
    if (query.type !== 'sales') {
      res = false
    }
    return res
  })

  const showInput = () => {
    if (isSalesPay.value) {
      show.value = true
    }
  }

  const AmountInput = (val) => {
    setTimeout(() => {
      Amount.value = clearNum(Amount.value)
    })
  }

  const ckeckCoupon = () => {
    // console.log('xuzne')
    couponShow.value = true
  }
  const hasCheck = () => {
    isCheck.value = !isCheck.value
  }
  const goAgreement = async () => {
    const H5Url = await store.getters['system/getH5Url']
    const url = `${H5Url}service/#/agreement?ProdId=${payData.value.Products[0].ProductId}&fromCase=true`
    window.location.href = url

    // router.push({
    //   path: '/agreement',
    //   query: {
    //     ProdId: payData.value.Products[0].ProductId,
    //   },
    // })
  }
</script>
<style lang="scss" scoped>
  .coupon-pay {
    text-align: center;
    font-size: 24px;
    padding: 10px 0 20px;
  }
  .check-box {
    margin-left: 5px;
    .check-text {
      color: rgba(0, 0, 0, 0.3);
    }
  }
  .content-coupon {
    padding: 14px 24px 24px;
    box-sizing: border-box;
    .coupon-title {
      text-align: center;
      background: #fff;
      margin-bottom: 10px;
    }
  }
  // .list {
  //   overflow: auto;
  // }
  .list-item {
    padding: 18px 30px 18px 5px;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    display: flex;
    margin-bottom: 15px;
  }
  .coupon {
    color: #fff;
    // margin-top: 24px;
    width: 100%;
    height: 150px;
    background: #fa5151;
  }
  .coupon-text1 {
    display: flex;
    align-items: center;
    padding: 0 20px;
    background-image: radial-gradient(
        circle at right bottom,
        #fff,
        #fff 20px,
        transparent 21px
      ),
      radial-gradient(circle at left bottom, #fff, #fff 20px, transparent 21px);
    border-bottom: 1px dashed #fff;
    height: 75px;
    margin-bottom: -2px;
    .coupon-money {
      width: 40%;
      .icon {
        font-size: 12px;
      }
      .price {
        font-size: 28px;
      }
    }
    .coupon-name {
      width: 60%;
      font-size: 16px;
    }
  }
  .coupon-text2 {
    padding: 10px 0;
    box-sizing: border-box;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 75px;
    background-image: radial-gradient(
        circle at right top,
        #fff,
        #fff 20px,
        transparent 21px
      ),
      radial-gradient(circle at left top, #fff, #fff 20px, transparent 21px);
  }
  .check-raido {
    margin-right: 5px;
    display: flex;
    align-items: center;
    .no-ckeck {
      color: rgba(0, 0, 0, 0.3);
    }
    .is-check {
      color: #fa5151;
    }
  }
  .protocol {
    display: flex;
    justify-content: center;
    font-size: 14px;
    margin-top: 10px;
    .protocol-text {
      a {
        text-decoration: underline;
      }
    }
    .protocol-icon {
      margin-right: 5px;
    }
  }
</style>
